import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';

@Component({
  selector: 'app-byoid-provisioning-modal',
  templateUrl: './byoid-provisioning-modal.component.html',
  styleUrls: ['./byoid-provisioning-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ByoidProvisioningModalComponent {
  readonly showModal = input<boolean>(false);
  readonly handleLogout = output<void>();

  onConfirm() {
    this.handleLogout.emit();
  }
}
